import { Component, getAssetPath, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'item-events',
  styleUrl: 'item-events.scss',
  shadow: true,
})
export class ItemEvents {
  @Prop() readonly item: IWCCurrentEvents;

  private handleEventClick = () => {
    window.open(this.item.url, '_blank', 'noopener,noreferrer');
  };

  private getDate() {
    const date = new Date(this.item.date * 1000);
    const lang = wcShared?.store?.utils?.getLang();

    const formattedDate = date.toLocaleString(lang + '-' + lang.toUpperCase(), {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });

    return formattedDate.replace(/\//g, '.');
  }

  private getHour() {
    const date = new Date(this.item.date * 1000);
    const lang = wcShared?.store?.utils?.getLang();

    return date.toLocaleString(lang + '-' + lang.toUpperCase(), {
      hour: 'numeric',
      minute: 'numeric',
    });
  }

  render() {
    return (
      <Host>
        <div
          class="item-events"
          onClick={this.handleEventClick}
        >
          <div class="item-events__info">
            <div class="label">{this.item.title}</div>
            <img
              src={getAssetPath('./../assets/icons/incidents.svg')}
              alt="events-icon"
            />
          </div>

          <div class="item-events__content">{this.item.description}</div>

          <div class="item-events__link-date">
            <a
              onClick={(e) => e.stopPropagation()}
              href={this.item.url}
              target="_blank"
              rel="noopener, noreferrer"
            >
              {wcShared?.translate('En savoir plus')}
            </a>
            <div class="date">
              {this.getDate()}
              <div class="bullet"></div>
              {this.getHour()}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
